export default __webpack_public_path__ + "static/media/swissimunity-wide@2x.9766d3d0.jpg";